<template>
    <van-cell-group>
        <van-field v-model="formData.password"
                   type="password"
                   label="新密码"
                   placeholder="请输入密码"
                   input-align="right"
                   :error="formValidate&&!formData.password"
        />
        <van-field v-model="formData.password2"
                   type="password"
                   label="确认新密码"
                   placeholder="请再次输入新密码"
                   :error="formValidate&&!formData.password2"
                   input-align="right"/>
        <van-field
                v-model="formData.code"
                center clearable label="短信验证码"
                placeholder="请输入短信验证码"
                :error="formValidate&&!formData.code"
        >
            <van-button slot="button" size="small" type="danger" background-color="red" @click="getCode">{{clockSecond>0? clockSecond+'s获取验证码':'获取验证码'}}</van-button>
        </van-field>
        <div class="btn">
            <van-button type="danger" round size="large" @click="formSave" v-if="!loading">确定</van-button>
            <van-button type="danger" round size="large" v-else>确定中...</van-button>
        </div>
        <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel" />
    </van-cell-group>
</template>
<style scoped>
    .btn {
        padding: 0 0.3rem;
        margin-top: 0.3rem;
    }

</style>

<script>
    import { Toast } from 'vant';
    import LoginDialog from '@/components/LoginDialog.vue';
    export default {
        name: 'Password',
        components: {
            Toast,LoginDialog
        },
        data: function () {
            return {
                loginShow:false,
                formData: {
                    password: '',
                    password2: '',
                    code: '',
                },
                clockSecond: 0,
                formValidate: false,
                loading: false
            }
        },
        filter: {},
        mounted() {
            document.title='修改密码'
        },
        destroyed() {
        },
        methods: {
            getCode() {
                let that = this;
                if (that.clockSecond > 0) {
                    return ;
                }
                this.$api.get('/api/user/phonecode', {}, (res) => {
                    Toast(res.msg)
                    that.clockSecond = 60;
                    var t = setInterval(function () {
                        if (that.clockSecond > 0) {
                            that.clockSecond = that.clockSecond-1
                        } else {
                            clearInterval(t);
                        }
                    }, 1000)
                },(res) => {
                    console.log(res);
                    if (res.code == 401 || res.code==402) {
                        that.loginShow = true
                    }else {
                        Toast(res.msg)
                    }
                    that.loading = false;
                })
            },

            loginSuccess(res){
                console.log('-------登录成功--------',res);
                this.loginShow = false;
            },

            loginCancel(){
                console.log('-------取消登录--------');
                // this.loginShow = false;
            },

            formSave() {
                let that = this;
                console.log(that.formData)
                for (let field in that.formData) {
                    if (!that.formData[field] && field !='_pspt') {
                        that.formValidate= true
                        return;
                    }
                };

                that.loading = true;
                this.$api.get('/api/user/editPassword', that.formData, (res) => {
                    rbLink({
                        name:'MineIndex'
                    })
                    that.loading = false;
                },(res) => {
                    if (res.code == 401 || res.code==402) {
                        that.loginShow = true
                    }else {
                        Toast(res.msg)
                    }
                    that.loading = false;
                })
            },
        }
    }
</script>



// WEBPACK FOOTER //
// Password.vue?16dc0d01